/* eslint-disable quote-props */
const stores = [
  {
    'id': 2300,
    'code': '2805',
    'type': '2in1-HS',
    'description': 'Currys PC World featuring Carphone Warehouse Tottenham Court Road',
    'address': '145 - 149 Tottenham Court Road',
    'town': 'London',
    'country': 'England',
    'postcode': 'W1T 7NE',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 0.9,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.523929,
      'longitude': -0.137407
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '19:00'
      },
      {
        'day': 7,
        'from': '12:00',
        'to': '18:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-05',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-26',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-08-25',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '19:00'
      }
    ],
    'facilities': [
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    'id': 6028,
    'code': '5211',
    'type': '2in1-HS',
    'description': 'Currys PC World featuring Carphone Warehouse Oxford Street ',
    'address': '94-98 Oxford Street',
    'town': 'London',
    'country': 'England',
    'postcode': 'W1D 1BZ',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 1.1,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.516285,
      'longitude': -0.135141
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '20:30'
      },
      {
        'day': 7,
        'from': '12:00',
        'to': '18:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-05',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-26',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-08-25',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:30'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '20:30'
      }
    ],
    'facilities': [
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      }
    ]
  },
  {
    'id': 3942,
    'code': '2815',
    'type': '2in1-HS',
    'description': 'Currys PC World featuring Carphone Warehouse Kensington High Street',
    'address': '47/53 Kensington High Street',
    'town': 'London',
    'country': 'England',
    'postcode': 'W8 5ED',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 2,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.502128,
      'longitude': -0.189571
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '19:00'
      },
      {
        'day': 7,
        'from': '12:00',
        'to': '18:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-05',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-26',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-08-25',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '19:00'
      }
    ],
    'facilities': [
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    'id': 4262,
    'code': '884',
    'type': '2in1-HS',
    'description': 'Currys PC World featuring Carphone Warehouse Barbican',
    'address': '14-20 Chiswell Street, Barbican',
    'town': 'London',
    'country': 'England',
    'postcode': 'EC1Y 4TW',
    'closedOnSaturday': false,
    'closedOnSunday': true,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 2.9,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.520881,
      'longitude': -0.089092
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '18:30'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '18:30'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '18:30'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '18:30'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '18:30'
      },
      {
        'day': 6,
        'from': '10:00',
        'to': '17:30'
      },
      {
        'day': 7,
        'from': '00:00',
        'to': '00:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-04-27',
        'from': '10:00',
        'to': '17:30'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-11',
        'from': '10:00',
        'to': '17:30'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-06-01',
        'from': '10:00',
        'to': '17:30'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '18:30'
      },
      {
        'date': '2019-08-31',
        'from': '10:00',
        'to': '17:30'
      },
      {
        'global': true,
        'date': '2019-08-25',
        'from': '00:00',
        'to': '00:00'
      },
      {
        'global': true,
        'date': '2019-08-26',
        'from': '00:00',
        'to': '00:00'
      }
    ],
    'facilities': [
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    'id': 7120,
    'code': '2679',
    'type': '2in1-HS',
    'description': 'Currys PC World featuring Carphone Warehouse White City Westfield',
    'address': 'Unit 2208, Level 50, Westfield Shopping Centre , Ariel Way London ',
    'town': 'Greater London ',
    'country': '',
    'postcode': 'W12 7GF',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 2.9,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.508869,
      'longitude': -0.221593
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 2,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 3,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 4,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 5,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 6,
        'from': '10:00',
        'to': '22:00'
      },
      {
        'day': 7,
        'from': '12:00',
        'to': '18:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-04-27',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-05',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-08',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-09',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-10',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-11',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-26',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-29',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-30',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-05-31',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-06-01',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-08-25',
        'from': '12:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-08-28',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-08-29',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-08-30',
        'from': '10:00',
        'to': '22:00'
      },
      {
        'date': '2019-08-31',
        'from': '10:00',
        'to': '22:00'
      }
    ],
    'facilities': [
      {
        'code': 'disabled_parking',
        'name': 'Disabled Parking'
      },
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      }
    ]
  },
  {
    'id': 1256,
    'code': '2445',
    'type': '2in1-MS',
    'description': 'Currys PC World featuring Carphone Warehouse Fulham',
    'address': 'Unit 2 Hurlingham Retail Park, 364 Wandsworth Bridge Road',
    'town': 'London',
    'country': 'England',
    'postcode': 'SW6 2TZ',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 4.2,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.465792,
      'longitude': -0.189831
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 7,
        'from': '11:00',
        'to': '17:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-05',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-26',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-25',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '20:00'
      }
    ],
    'facilities': [
      {
        'code': 'retail_park_parking',
        'name': 'Retail Park Parking'
      },
      {
        'code': 'disabled_parking',
        'name': 'Disabled Parking'
      },
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'dyson',
        'name': 'Dyson'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    'id': 6331,
    'code': '2432',
    'type': '2in1-MS',
    'description': 'Currys PC World featuring Carphone Warehouse Staples Corner ',
    'address': '4 Staples Corner Retail Park, Geron Way',
    'town': 'London',
    'country': 'England',
    'postcode': 'NW2 6LU',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 4.3,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.569061,
      'longitude': -0.23008
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '21:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '21:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '21:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '21:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '21:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '19:00'
      },
      {
        'day': 7,
        'from': '11:00',
        'to': '17:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-05',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-05-26',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '19:00'
      },
      {
        'date': '2019-08-25',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '21:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '19:00'
      }
    ],
    'facilities': [
      {
        'code': 'retail_park_parking',
        'name': 'Retail Park Parking'
      },
      {
        'code': 'disabled_parking',
        'name': 'Disabled Parking'
      },
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_clinic',
        'name': 'KnowHow Clinic'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'dyson',
        'name': 'Dyson'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    'id': 1565,
    'code': '2375',
    'type': '2in1-MS',
    'description': 'Currys PC World featuring Carphone Warehouse Mile End Road',
    'address': 'Unit 2-3 Anchor House, 123 Mile End Road',
    'town': 'London',
    'country': 'England',
    'postcode': 'E1 4UJ',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 4.6,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.521466,
      'longitude': -0.051239
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '18:00'
      },
      {
        'day': 7,
        'from': '11:00',
        'to': '17:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-04-26',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-04-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-05',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-06',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-07',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-08',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-09',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-26',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-25',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '18:00'
      }
    ],
    'facilities': [
      {
        'code': 'retail_park_parking',
        'name': 'Retail Park Parking'
      },
      {
        'code': 'disabled_parking',
        'name': 'Disabled Parking'
      },
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'dyson',
        'name': 'Dyson'
      }
    ]
  },
  {
    'id': 1503,
    'code': '2274',
    'type': '2in1-SS',
    'description': 'Currys PC World featuring Carphone Warehouse Brixton',
    'address': 'Unit A 51-57 Effra Road',
    'town': 'London',
    'country': 'England',
    'postcode': 'SW2 1BZ',
    'closedOnSaturday': false,
    'closedOnSunday': false,
    'payAndCollectAvailable': true,
    'distance': {
      'value': 4.8,
      'unit': 'miles'
    },
    'location': {
      'latitude': 51.45845,
      'longitude': -0.114167
    },
    'standardOpeningHours': [
      {
        'day': 1,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 2,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 3,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 4,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 5,
        'from': '09:00',
        'to': '20:00'
      },
      {
        'day': 6,
        'from': '09:00',
        'to': '18:00'
      },
      {
        'day': 7,
        'from': '11:00',
        'to': '17:00'
      }
    ],
    'exceptionalDates': [
      {
        'date': '2019-05-10',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-11',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-26',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-05-27',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-05-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-05-31',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-06-01',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-25',
        'from': '11:00',
        'to': '17:00'
      },
      {
        'date': '2019-08-26',
        'from': '09:00',
        'to': '18:00'
      },
      {
        'date': '2019-08-27',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-28',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-29',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-30',
        'from': '09:00',
        'to': '20:00'
      },
      {
        'date': '2019-08-31',
        'from': '09:00',
        'to': '18:00'
      }
    ],
    'facilities': [
      {
        'code': 'retail_park_parking',
        'name': 'Retail Park Parking'
      },
      {
        'code': 'disabled_parking',
        'name': 'Disabled Parking'
      },
      {
        'code': 'disabled_access',
        'name': 'Disabled Access'
      }
    ],
    'services': [
      {
        'code': 'knowhow_service_bar',
        'name': 'KnowHow Service Bar'
      },
      {
        'code': 'business_centre',
        'name': 'Business Centre'
      },
      {
        'code': 'recycling',
        'name': 'Recycling'
      },
      {
        'code': 'apple',
        'name': 'Apple'
      },
      {
        'code': 'samsung',
        'name': 'Samsung'
      }
    ]
  },
  {
    id: 9997,
    code: '779',
    type: 'CDG-HS',
    description: 'Currys.Test2',
    address: '',
    town: 'Eastbourne',
    country: 'England',
    postcode: 'NW1 0LU',
    closedOnSaturday: true,
    closedOnSunday: false,
    payAndCollectAvailable: false,
    distance: {
      value: 4.2,
      unit: 'miles'
    },
    location: {
      latitude: 50.762270,
      longitude: 0.277673
    },
    standardOpeningHours: [
      {
        day: 1,
        from: '09:30',
        to: '18:30'
      },
      {
        day: 2,
        from: '09:30',
        to: '18:30'
      },
      {
        day: 3,
        from: '09:30',
        to: '18:30'
      },
      {
        day: 4,
        from: '09:30',
        to: '18:30'
      },
      {
        day: 5,
        from: '09:30',
        to: '18:30'
      },
      {
        day: 6,
        from: '09:30',
        to: '18:00'
      },
      {
        day: 7,
        from: '11:00',
        to: '17:00'
      }
    ],
    exceptionalDates: [],
    facilities: [],
    services: [
      {
        code: 'knowhow_service_bar',
        name: 'KnowHow Service Bar'
      },
      {
        code: 'currys-pc-world-business',
        name: 'Currys PC World Business'
      }
    ]
  }
];

export default stores;
